module.exports = __webpack_public_path__ + "img/lookbook_3_center.db18b2fd.png";